<script setup lang="ts">
const items = [
  {
    title: 'Proses Cepat & Transparan',
    description: 'Klaim langsung diproses begitu laporan masuk.',
    icon: 'material-symbols:visibility-outline'
  },
  {
    title: 'Lacak Status Real-Time',
    description: 'Pantau posisi klaimmu setiap saat.',
    icon: 'material-symbols:track-changes'
  },
  {
    title: 'Dokumentasi Otomatis',
    description: 'Semua bukti tersimpan rapi di dashboard.',
    icon: 'material-symbols:description-outline'
  },
  {
    title: 'Pencairan Langsung ke Akun',
    description: 'Tanpa administrasi manual.',
    icon: 'material-symbols:person-search-outline'
  }
]

const { isMobile } = useBreakpoints()
</script>

<template>
  <UiSectionWrapper
    title="Klaim Cepat, Aman, dan Bisa Dipantau Real-Time"
    hero-image="/images/klaim-asuransi-dan-retur-banner-3.webp"
    class="py-12"
  >
    <template #action>
      <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="flex items-start gap-3"
        >
          <div
            class="p-2 rounded-full bg-primary-container flex-none text-primary"
          >
            <Icon :name="item.icon" :size="isMobile ? '22px' : '30px'" />
          </div>
          <div class="flex-1 flex flex-col gap-2">
            <p class="text-sm lg:text-xl font-bold lg:font-semibold">
              {{ item.title }}
            </p>
            <p class="text-sm lg:text-base text-outline">
              {{ item.description }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </UiSectionWrapper>
</template>
